export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: 'edd3f80', dateTime: 1770660034246 };